module.exports = __webpack_public_path__ + "pcsg/img/may11.9669ecfc.png";